{
  "name": "apps-manager",
  "version": "1.37.0",
  "packageManager": "pnpm@10.34.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration local",
    "bump": "pnpm run bump:minor",
    "bump:major": "pnpm version --no-git-tag-version major",
    "bump:minor": "pnpm version --no-git-tag-version minor",
    "bump:patch": "pnpm version --no-git-tag-version patch",
    "postversion": "sed -i.bak -E \"s/^## \\[?Unreleased\\]?/## [$npm_package_version] - ?/\" CHANGELOG.md && rm CHANGELOG.md.bak",
    "test": "ng test",
    "lint": "ng lint && pnpm lint:html",
    "lint:html": "htmlhint src",
    "lint:fix": "ng lint --fix",
    "plop": "plop --plopfile tools/plop/index.js",
    "translations:extract": "ngx-translate-extract --input ./src --output ./src/assets/i18n/{fr,en,de,es}.json --format=namespaced-json --format-indentation '  ' --clean --sort",
    "e2e": "ng e2e --watch=false",
    "e2e:watch": "ng e2e",
    "prepare": "husky install"
  },
  "private": true,
  "lint-staged": {
    "src/**/*": [
      "eslint"
    ]
  },
  "dependencies": {
    "@amplitude/analytics-browser": "^2.8.0",
    "@angular/animations": "^21.2.7",
    "@angular/cdk": "21.2.5",
    "@angular/common": "^21.2.7",
    "@angular/compiler": "^21.2.7",
    "@angular/core": "^21.2.7",
    "@angular/forms": "^21.2.7",
    "@angular/google-maps": "21",
    "@angular/material": "21.2.5",
    "@angular/material-moment-adapter": "^21.2.5",
    "@angular/platform-browser": "^21.2.7",
    "@angular/platform-browser-dynamic": "^21.2.7",
    "@angular/router": "^21.2.7",
    "@angular/service-worker": "^21.2.7",
    "@colsen1991/ngx-translate-extract-marker": "^2.0.8",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@messageformat/core": "^3.3.0",
    "@ngx-translate/core": "17",
    "@ngxs-labs/dispatch-decorator": "5.0.0",
    "@ngxs/router-plugin": "21",
    "@ngxs/storage-plugin": "21",
    "@ngxs/store": "21",
    "@typeform/embed": "^5.5.0",
    "@types/js-cookie": "^3.0.6",
    "@typescript-eslint/typescript-estree": "^8.58.0",
    "@vendure/ngx-translate-extract": "^9.1.0",
    "angular-google-tag-manager": "1.13.0",
    "chart.js": "^4.4.3",
    "cropperjs": "^1.6.2",
    "js-cookie": "3.0.1",
    "moment": "^2.29.4",
    "ng-circle-progress": "^1.7.1",
    "ng2-charts": "10",
    "ngx-color-picker": "^16.0.0",
    "ngx-editor": "^17.5.4",
    "ngx-translate-messageformat-compiler": "^7.0.0",
    "rxjs": "^7.8.1",
    "tslib": "^2.6.2",
    "zone.js": "~0.16.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^21.0.1",
    "@angular-eslint/eslint-plugin": "^21.0.1",
    "@angular-eslint/eslint-plugin-template": "^21.0.1",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular-eslint/template-parser": "^21.0.1",
    "@angular/build": "^21.2.6",
    "@angular/cli": "^21.2.6",
    "@angular/compiler-cli": "^21.2.7",
    "@cypress/schematic": "^2.5.1",
    "@types/jasmine": "~4.3.0",
    "@typescript-eslint/eslint-plugin": "^8.58.0",
    "@typescript-eslint/parser": "^8.58.0",
    "autoprefixer": "^10.4.13",
    "cypress": "latest",
    "eslint": "^9.8.0",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-no-null": "^1.0.2",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-unicorn": "^45.0.1",
    "htmlhint": "^1.1.4",
    "husky": "^8.0.0",
    "inquirer-directory": "^2.2.0",
    "lint-staged": "^15.2.4",
    "plop": "^3.1.1",
    "postcss": "^8.4.19",
    "prettier": "3.1",
    "tailwindcss": "^3.4.1",
    "typescript": "~5.9.3"
  },
  "pnpm": {
    "overrides": {
      "prosemirror-model": "1.21.0"
    },
    "onlyBuiltDependencies": [
      "@parcel/watcher",
      "cypress",
      "esbuild",
      "lmdb",
      "msgpackr-extract"
    ]
  }
}
